<template>
    <div class="indemnity-description-container">
        <typo
            name="body-14-normal"
            v-if="indemnity.amountForSeniority"
            v-html="indemnity.amountForSeniority"
        >
            {{ indemnity.amountForSeniority }}
        </typo>
    </div>
</template>

<script>
export default {
    props: ["indemnity"],
};
</script>

<style scoped lang="sass">
.indemnity-description-container
    display: flex
    flex-direction: column
    width: 450px
    margin: 0 16px
    padding: 0 16px
</style>
